import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminRouting } from './admin.routing';
import { AuthguardService, AdminguardService } from '../../guards';
import { SharedModule } from '../shared/shared.module';
import { WidgetconfigComponent } from './widgetconfig/widgetconfig.component';

@NgModule({
    imports: [
      CommonModule,
      SharedModule,
      AdminRouting
    ],
    declarations: [
        WidgetconfigComponent
    ],
    providers: [
      AuthguardService, 
      AdminguardService
    ]
  })
  export class AdminModule { }
  


// WEBPACK FOOTER //
// ./src/app/components/admin/admin.module.ts